import { render, staticRenderFns } from "./PackNamingSection.vue?vue&type=template&id=49b62c4f&"
import script from "./PackNamingSection.vue?vue&type=script&lang=js&"
export * from "./PackNamingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports